import React, { useState } from 'react';
import { Grid, TextField, Button, CircularProgress, Box } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline'; // Corretto l'import standard di MUI
import { TelegramInviteDialog } from './TelegramInviteDialog';
import {createTelegramInvitation} from "@/queries/socialQueries";

// Definiamo l'interfaccia per il social account passata come prop
interface SocialAccount {
    name: string;
    // Puoi aggiungere altri campi se necessari in futuro
}

interface TelegramAccountFormProps {
    socialAccount: SocialAccount;
}

export const TelegramAccountForm: React.FC<TelegramAccountFormProps> = ({ socialAccount }) => {
    // Stati per la gestione del popup e della chiamata API
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [inviteLink, setInviteLink] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    // Funzione che gestisce il click e fa la richiesta (simulata)
    const handleGenerateInvitation = async () => {
        setLoading(true);
        try {
            const response = await createTelegramInvitation()
            setInviteLink(response.invite);
            setIsDialogOpen(true);
        } catch (error) {
            console.error("Error generating Telegram invitation:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: 'center',
                gap: 2,
                mb: 2,
                width: '100%'
            }}>
                <Box sx={{ flexGrow: 1, width: { xs: '100%', lg: 'auto' } }}>
                    <TextField
                        slotProps={{
                            input: { readOnly: true }
                        }}
                        value={socialAccount.name}
                        name={"Name"}
                        placeholder={"Name"}
                        label={"Name"}
                        type={'text'}
                        variant={'outlined'}
                        fullWidth
                    />
                </Box>

                <Box sx={{
                    width: { xs: '100%', lg: '21%' },
                    minWidth: { lg: '300px' },
                    flexShrink: 0
                }}>
                    <Button
                        variant={"contained"}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <MailOutlineIcon />}
                        onClick={handleGenerateInvitation}
                        disabled={loading || !socialAccount.name}
                        fullWidth
                    >
                        {loading ? 'Generating...' : 'Generate Invite'}
                    </Button>
                </Box>
            </Box>

            {/* Popup controllato internamente dallo stato del form */}
            <TelegramInviteDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                inviteLink={inviteLink}
            />
        </>
    );
};